<template>
  <div>
    <b-row>
      <b-col>
        <b-button
          v-b-toggle.sidebar-dashboard-brand
          size="sm"
          variant="outline-dark"
          pill
          style="position: absolute; top: 3.5rem;"
        >
          {{ brand }}
        </b-button>
        <b-sidebar
          class="pbi-sidebar"
          id="sidebar-dashboard-brand"
          title="Dashboard"
          bg-variant="dark"
          text-variant="light"
          shadow
          no-title
          backdrop
        >
          <div class="px-3 py-2 text-dark">
            <treeselect v-model="brand" :options="brands" :clearable="false" />
          </div>
        </b-sidebar>

        <b-button
          size="sm"
          variant="outline-secondary"
          @click="sidebarVisible = !sidebarVisible"
          pill
          style="position: absolute; top: 1rem;"
        >
          {{ $route.query.name || 'Menu' }}
        </b-button>
        <b-sidebar
          v-model="sidebarVisible"
          class="pbi-sidebar"
          id="sidebar-dashboard-menu"
          title="Dashboard"
          bg-variant="dark"
          text-variant="light"
          shadow
        >
          <side-bar
            :menu="filteredList"
            @dashboardSelected="dashboardSelected"
          />
        </b-sidebar>
        <pbi-report-viewer
          v-if="powerBiEmbedUrlId && brand"
          :powerBiEmbedUrlId="powerBiEmbedUrlId"
          :brand="brand"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import _ from 'lodash';
import http from '@/mixins/http';
import SideBar from '@/components/dashboard/SideBar';
import PbiReportViewer from '@/views/dashboard/PbiReportViewer';

export default {
  name: 'Brand',
  mixins: [http],
  components: { SideBar, PbiReportViewer },
  mounted() {
    this.getMenu();
    if(this.brands.length) {
      this.brand = this.brands[0].id;
    }
  },
  watch: {
    '$route.params'() {
      this.powerBiEmbedUrlId = this.$route.params.id;
    },
    brands() {
      if(this.brands.length) {
        this.brand = this.brands[0].id;
      }
    },
  },
  data() {
    return {
      sidebarVisible: true,
      selectedDashboard: 'Menu',
      powerBiEmbedUrlId: '',
      list: [
        {
          dashboardId: 1,
          title: 'Business Performance',
          href: null,
          parentId: -1,
        },
      ],
      brand: '',
    };
  },
  computed: {
    filteredList() {
      let list = _.sortBy(this.list, ['parentId']);
      // remove /dashboard from the url due to legacy settings
      list = _.map(list, item => {
        if (item.href) {
          item.href = item.href.replace('/dashboard', '');
        }
        return item;
      });

      const roots = _.filter(list, { parentId: 1 });
      return _.map(roots, root => {
        return this.getNestedList(root, list);
      });
    },
    brands() {
      const user = this.$store.state.user;
      if (user) {
        const brands = _.map(user.brandPermission, brand => {
          return {
            id: brand,
            label: brand,
          };
        });
        return brands;
      }
      return [];
    },
  },
  methods: {
    getMenu() {
      this.axios.get('/api/dashboard/dashboards').then(resp => {
        if (resp.data) {
          this.list = resp.data;
        }
      });
    },
    dashboardSelected(dashboardName) {
      this.selectedDashboard = dashboardName;
    },
    getNestedList(root, adjacencyList) {
      const added = {};
      const rootNode = _.cloneDeep(root);
      const SetDepth = function(currentNode) {
        added[currentNode.dashboardId] = true;
        while (
          _.some(adjacencyList, function(node) {
            return (
              node.parentId === currentNode.dashboardId &&
              !added[node.dashboardId]
            );
          })
        ) {
          let childNode = _.find(adjacencyList, function(node) {
            return (
              node.parentId === currentNode.dashboardId &&
              !added[node.dashboardId]
            );
          });
          if (!Object.prototype.hasOwnProperty.call(currentNode, 'child')) {
            currentNode.child = [];
          }
          if (
            !_.some(currentNode.child, { dashboardId: childNode.dashboardId })
          ) {
            currentNode.child.push(childNode);
          }
          added[childNode.dashboardId] = true;
          SetDepth(childNode, adjacencyList);
        }
      };
      if (rootNode) {
        SetDepth(rootNode);
      }
      return rootNode;
    },
  },
};
</script>

<style scoped></style>